/* eslint-disable */
type GUID = string;
type DeviceID = GUID;
type NodeID = GUID;
type Label = string;
type SourceIDUnion = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9';

// Video format “mp4”: Fragmented MP4
// Video format “raw”: Raw H264 Annex-B NALs
// Video format “avcc”: AVCC format H264 NALs
type StreamerModeUnion = 'mp4' | 'raw' | 'avc';

const DEFAULT_SOURCE = '1';
const DEFAULT_WIDTH = 150;
const DEFAULT_HEIGHT = 50;

interface ICommonRequestMessageOptions {
  deviceId: DeviceID;
  nodeId: NodeID;
  label: Label;
  source?: SourceIDUnion;
  width?: number; // seems to be ignored?
  height?: number; // seems to be ignored?
  metadataOnly?: boolean;
  includeAudio?: boolean;
  uiDrivenSync?: boolean;
  videoCodecs?: ['H264']; // at some point we could theoretically support h265
}

class RequestMessage {
  deviceId: DeviceID;
  nodeId: NodeID;
  label: Label;
  source: SourceIDUnion;
  width: number;
  height: number;
  metadataOnly: boolean;
  includeAudio: boolean;
  uiDrivenSync: boolean; // TODO: ask Ava what this means
  videoCodecs: string[];
  mode: StreamerModeUnion;

  constructor(label: Label, options: ICommonRequestMessageOptions) {
    this.label = label;
    this.deviceId = options.deviceId;
    this.nodeId = options.nodeId;
    this.source = options.source || DEFAULT_SOURCE;
    this.width = options.width || DEFAULT_WIDTH;
    this.height = options.height || DEFAULT_HEIGHT;
    this.metadataOnly = options.metadataOnly || false;
    this.includeAudio = options.includeAudio ?? false;
    this.uiDrivenSync = options.uiDrivenSync || true;
    this.videoCodecs = options.videoCodecs || ['H264']; // at some point we could theoretically support h265
    this.mode = 'mp4';
  }

  // don't love this pattern!
  toObject(request_type: 'playback' | 'stream', merge = {}) {
    return {
      type: 'webrtc_dynamic_request',
      request_type,
      label: this.label,
      request: {
        deviceId: this.deviceId,
        nodeId: this.nodeId,
        source: this.source,
        width: this.width,
        height: this.height,
        metadataOnly: this.metadataOnly,
        include_audio: this.includeAudio, // case change
        uiDrivenSync: this.uiDrivenSync,
        videoCodecs: this.videoCodecs,
        ...merge,
      },
    };
  }
}

export interface ILiveRequestMessageOptions
  extends ICommonRequestMessageOptions {}

export class LiveRequestMessage extends RequestMessage {
  toObject() {
    return super.toObject('stream');
  }
}

export interface IPlaybackMessageOptions extends ICommonRequestMessageOptions {
  startTimestamp: Date;
  endTimestamp?: Date;
  speed?: number;
  noSkipPauses?: boolean;
}

export class PlaybackRequestMessage extends RequestMessage {
  startTimestamp: Date;
  endTimestamp?: Date;
  speed: number;
  noSkipPauses: boolean;

  constructor(label: Label, options: IPlaybackMessageOptions) {
    super(label, options);

    this.startTimestamp = options.startTimestamp;
    this.endTimestamp = options.endTimestamp;

    this.speed = options.speed || 1;
    this.noSkipPauses = options.noSkipPauses || false;
  }

  toObject() {
    return super.toObject('playback', {
      speed: this.speed,
      noSkipPauses: this.noSkipPauses,
      startTimestamp: this.startTimestamp.toISOString(),
      ...(this.endTimestamp && { endTimestamp: this.endTimestamp }),
    });
  }
}
